export const getters = {
  getAuthenticationState: (state) => {
    return state.isAuthenticated;
  },

  getUserInfo: (state) => {
    return state.userInfo;
  },
};
